import { FC, useEffect } from "react";
import { Skeleton } from "@mui/material";
import "@xyflow/react/dist/style.css";
import { ReactFlowProvider } from "@xyflow/react";
import { useParams } from "react-router-dom";
import useGetEmployee from "src/Pages/Company/OrganizationStructure/api/useGetEmployee";
import { useFormContext } from "react-hook-form";
import { OrgchartType } from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/FilterBar.models";
import OrgchartTree from "./OrgchartTree";
import FilterBar from "./FilterBar";
import { useEmployeesOrgchartData } from "./api";

interface IEmployeesOrgchartDataProvider {
  companyId: string;
  structureId: string;
}

const EmployeesOrgchartDataProvider: FC<IEmployeesOrgchartDataProvider> = ({
  companyId,
  structureId,
}) => {
  const { orgchartType, nodeId } = useParams() as {
    orgchartType: OrgchartType;
    nodeId: string | undefined;
  };
  const { isLoading } = useEmployeesOrgchartData({ companyId, structureId });
  const methods = useFormContext();

  const searchBarEmployee = useGetEmployee({
    enabled: !!nodeId && orgchartType === OrgchartType.Employees,
    employeeId: nodeId || "",
  });

  useEffect(() => {
    if (
      searchBarEmployee.data &&
      nodeId &&
      orgchartType === OrgchartType.Employees
    ) {
      methods.setValue("autocomplete", {
        id: nodeId,
        label: `${searchBarEmployee.data.firstName} ${searchBarEmployee.data.lastName}`,
        initials: `${searchBarEmployee.data.firstName[0]}${searchBarEmployee.data.lastName[0]}`,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchBarEmployee.data]);

  return (
    <ReactFlowProvider>
      <FilterBar companyId={companyId} structureId={structureId} />
      {isLoading ? (
        <Skeleton variant="rectangular" height={600} />
      ) : (
        <OrgchartTree />
      )}
    </ReactFlowProvider>
  );
};

export default EmployeesOrgchartDataProvider;
